import React from 'react';
import {
  CardHeader,
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Row,
} from 'reactstrap';
import CTooltip from "react-tooltip-lite";
import ErrorBoundary from 'components/ErrorBoundary';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import ClaimsWidget from './components/ClaimsWidget';
import CapturedvsReplenished from './components/CapturedvsReplenished';
import TopLocation from './components/TopLocation';
import BarWidget from './components/BarWidget';
import TopTPA from './components/Widgets/TopTPA';
import Loader from 'components/Loader';
import TopPharmacy from './components/Widgets/TopPharmacy';
import TopDrugs from './components/Widgets/TopDrugs';
import ThirdPartyCase from './components/Widgets/ThirdPartyCase';
import TopCoveredEntities from './components/Widgets/TopCoveredEntities';
import BrandGeneric from './components/Widgets/BrandGeneric';
// import BarWidget from "./components/BarWidget";
import RevenueMonthWidget from './components/RevenueMonthWidget';
import ContractsAndCEs from './components/ContractsAndCEs';
import ProgramRevenue from './components/ProgramRevenue';

import SearchDashBoard from './SearchDashBoard';
import { useState } from 'react';
import { useEffect } from 'react';
// import ThirdPartyWidget from "./components/ThirdPartyWidget";
import FinacialIcon from "../../assets/icon/DashboardFinacial.svg";
import DashboardProgram from "../../assets/icon/DashboradHelathIcon.svg";
import DashboardHealthimages from "../../assets/icon/DashboardHealthimages.svg";
import DashboardHelath1 from "../../assets/icon/HealthImage2.svg";
import DashboardHelath2 from "../../assets/icon/HealthImg2.svg";
import TopNDCs from './components/Widgets/TopNDCs';
import BottomPharmacy from './components/Widgets/BottomPharmacy';


let defaultValue = {
  dateRangeID: 4,
  thirdPartyAdminID: 0
};
const Dashboard = () => {
  const API = useAxios();
  const [counterData, setCounterData] = useState([
    {
      "name": "Captured Claims",
      "iconName": "Captured Claims",
      "tooltip": "The number of claims captured during the selected time frame."
    },
    {
      "name": "Replenished Claims",
      "iconName": "Replenished Claims",
      "tooltip": "The number of claims Replenished during the selected time frame."
    },
    {
      "name": "Dispense Fee Revenue",
      "iconName": "Dispensing Fee Revenue",
      "tooltip": "The total calculated dispense fees for all replenished claims during the selected time frame."
    },
    {
      "name": "Inventory Savings",
      "iconName": "Inventory Savings ",
      "tooltip": "Est. WAC Retail Cost for all replenished claims during the selected time frame."
    },
    {
      "name": "Total Program Value ",
      "iconName": "Total Program Value ",
      "tooltip": "Sum of Dispense Fee Revenue and Inventory Savings for the selected time frame."
    }
  ]);
  const [loading, setLoading] = useState(false);
  const [months, setMonths] = useState([]);
  const [pharmacies, setPharmacies] = useState([]);
  const [ces, setCes] = useState([]);
  const [replenished, setReplenished] = useState([]);
  const [filesData, setFilesData] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [dispFee, setdispFee] = useState([]);
  const [capture, setCapture] = useState([]);
  const [top10ces, setTop10CEs] = useState([]);
  const [top10phs, setTop10PHs] = useState([]);
  const [bottom10phs, setBottom10PHs] = useState([]);
  const [top10ndcs, setTop10NDCs] = useState([]);
  const [thirdParty, setThirdParty] = useState([]);
  const [cash, setCash] = useState([]);
  //const [topTPAs, setTopTPAs] = useState([]);
  //const [topCEs, setTopCEs] = useState([]);
  //const [topPharmacies, setTopPharmacies] = useState([]);
  const {
    states: { dashboard },
    setStates,
  } = useContextService();
  const { search, thirdPartyAdmin, searchTerms } = dashboard;

  // useEffect(() => {
  //   initialFetch();
  // }, []);
  const { tenantID } = thirdPartyAdmin;

  const initialFetch = async () => {
    fetchMonths(defaultValue.dateRangeID);
    // fetchClaimCount(defaultValue.thirdPartyAdminID, defaultValue.dateRangeID);
    // fetchLineGraphs()
    // fetchContracts(defaultValue.thirdPartyAdminID, defaultValue.dateRangeID);
    // fetchTopValues(defaultValue.thirdPartyAdminID, defaultValue.dateRangeID);
  };

   const handleSearch = async (filters) => {
    setLoading(true); // Show the loader
    const { thirdPartyAdminID, dateRangeID } = filters;
    const fetchRequests = [
      fetchLineGraphs(filters),
      fetchClaimCount(filters),
      fetchMonths(dateRangeID),
      fetchBarGraphs(filters),
    ];
    try {
      const results = await Promise.allSettled(fetchRequests); // Run all requests concurrently
      console.log(results,"results")
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Hide the loader when all requests are done
    }
  };


  const fetchMonths = async (dateRangeID) => {
    if (!tenantID) {
      return null;
    } try {
      const { data } = await API.get(
        `GWDashBoard/${tenantID}/DashBoard/getmonths/${dateRangeID}`, {
        hasDefaultURL: true,
        hideLoader: false,
      }
      );
      if (data) {
        setMonths(data);
      } else {
        setMonths([]);
      }
    } catch (error) { }

  };

  const fetchLineGraphs = async (filters) => {
    if (!tenantID) {
      return null;
    } const {
      thirdPartyAdminID,
      coveredEntityIDS,
      pharmacyIDS,
      dateRangeID,
    } = filters;

    let tpaID = 0
    if (thirdPartyAdminID) tpaID = thirdPartyAdminID;
    if (!tenantID) return null;
    var payload = {};
    try {
      coveredEntityIDS ? payload.ceids = coveredEntityIDS : payload.ceids = []
      pharmacyIDS ? payload.phids = pharmacyIDS : payload.phids = []
      payload.daterangeid = dateRangeID;
      let tpaID = 0
      if (thirdPartyAdminID) tpaID = thirdPartyAdminID;
      const { data } = await API.post(
        `GWDashBoard/${tenantID}/DashBoard/getlinegraphvalues/${tpaID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: false,
        }
      );
      if (data) {
        // set340BDrug(data.totalInvoicedAmount340B);
        // setNon340BDrug(data.totalInvoicedAmountNon340B);
        setCapture(data.capturedCount);
        setReplenished(data.replenishedCount);
        setdispFee(data.dispenseFeeRev);
        // setSavings340B(data.savings340B);
        // setSavingsNon340B(data.savingsNon340B);
        setCes(data.cEs)
        setContracts(data.contracts);
        setCash(data.cash);
      } else {
        // set340BDrug([]);
        // setNon340BDrug([]);
        setCapture([]);
        setReplenished([]);
        setdispFee([]);
        setCes([]);
        // setSavings340B([]);
        // setSavingsNon340B([]);
        setContracts([]);
        setCash([]);
      }
    } catch (error) { }

  };

  const fetchBarGraphs = async (filters) => {
    if (!tenantID) {

      return null;
    } const {
      thirdPartyAdminID,
      coveredEntityIDS,
      pharmacyIDS,
      dateRangeID,
    } = filters;

    let tpaID = 0
    if (thirdPartyAdminID) tpaID = thirdPartyAdminID;
    if (!tenantID) return null;
    var payload = {};
    try {
      coveredEntityIDS ? payload.ceids = coveredEntityIDS : payload.ceids = []
      pharmacyIDS ? payload.phids = pharmacyIDS : payload.phids = []
      payload.daterangeid = dateRangeID;
      let tpaID = 0
      if (thirdPartyAdminID) tpaID = thirdPartyAdminID;
      const { data } = await API.post(
        `GWDashBoard/${tenantID}/DashBoard/getBarGraphValues/${tpaID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: false,
        }
      );
      if (data) {
        setTop10CEs(data.cEs);
        setTop10PHs(data.pharmacies);
        setBottom10PHs(data.bottom10Pharmacies);
        setTop10NDCs(data.ndCs)
      } else {
        setTop10CEs([]);
        setTop10PHs([]);
        setBottom10PHs([]);
        setTop10NDCs([]);
      }
    } catch (error) { }

  };


  const fetchClaimCount = async (filters) => {
    if (!tenantID) {
      return null;
    } const {
      thirdPartyAdminID,
      coveredEntityIDS,
      pharmacyIDS,
      dateRangeID,
    } = filters;

    let tpaID = 0
    if (thirdPartyAdminID) tpaID = thirdPartyAdminID;
    var payload = {};
    try {
      coveredEntityIDS ? payload.ceids = coveredEntityIDS : payload.ceids = []
      pharmacyIDS ? payload.phids = pharmacyIDS : payload.phids = []
      payload.daterangeid = dateRangeID;

      const { data } = await API.post(
        `GWDashBoard/${tenantID}/DashBoard/getcounts/${tpaID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: false,
        }

      );
      if (data) {
        setCounterData(data);
      } else {
        setCounterData([]);
      }
    } catch (error) { }
  };

  const fetchContracts = async (thirdPartyAdminID, dateRangeID) => {
    if (!tenantID) return null;
    try {
      let tpaID = 0
      if (thirdPartyAdminID) tpaID = thirdPartyAdminID;

      const { data } = await API.get(
        `GWDashBoard/${tenantID}/DashBoard/GetContracts/${tpaID}/${dateRangeID}`, {
        hasDefaultURL: true,
        hideLoader: false,
      }
      ); info
      if (data) {
        setPharmacies(data.pharmacies);
        setCes(data.coveredEntities);
        setCapture(data.capturedCount);
        setReplenished(data.replenishedCount);
        setdispFee(data.dispenseFeeRev);
        setThirdParty(data.thirdparty);
        setCash(data.cash);
      } else {
        setPharmacies([]);
        setCes([]);
        setCapture([]);
        setReplenished([]);
        setdispFee([]);
        setThirdParty([]);
        setCash([]);
      }
    } catch (error) { }
  };

  const handleReset = () => {
    setCapture([]);
    setReplenished([]);
    setMonths([]);
    setdispFee([]);
    setCes([]);
    setTop10CEs([]);
    setTop10NDCs([]);
    setBottom10PHs([]);
    setTop10PHs([]);
    // setSavings340B([]);
    // setSavingsNon340B([]);
    setContracts([]);
    setCash([]);
    // setCounterData([]);

    initialFetch();
    setCounterData([
      {
        "name": "Captured Claims",
        "iconName": "Captured Claims",
        "tooltip": "The number of claims captured during the selected time frame."
      },
      {
        "name": "Replenished Claims",
        "iconName": "Replenished Claims",
        "tooltip": "The number of claims Replenished during the selected time frame."
      },
      {
        "name": "Dispense Fee Revenue",
        "iconName": "Dispensing Fee Revenue",
        "tooltip": "The total calculated dispense fees for all replenished claims during the selected time frame."
      },
      {
        "name": "Inventory Savings",
        "iconName": "Inventory Savings ",
        "tooltip": "Est. WAC Retail Cost for all replenished claims during the selected time frame."
      },
      {
        "name": "Total Program Value ",
        "iconName": "Total Program Value ",
        "tooltip": "Sum of Dispense Fee Revenue and Inventory Savings for the selected time frame."
      }
    ]);
  };

  return (
    <div>
        {loading && <Loader opacity={0.01}/>}
    <div>
      <Container fluid className='width-info'>
        <div className={"mb-0"}>


          <Card className="border-0 shadow-top " style={{ marginTop: "82px" }}>
            <CardBody>
              <ErrorBoundary>
                <SearchDashBoard onReset={handleReset} onSearch={handleSearch} />
              </ErrorBoundary>
            </CardBody>
          </Card>

        </div>
        <Card className="border-0 shadow-top mt-2">
          <CardBody>
            <Row sm={2} xs={1}>
              <p style={{ fontSize: 'x-large', fontWeight: '600', marginBottom: '-7', marginTop: '5px', marginLeft: 'initial' }}>Program Overview</p>

              <Col md={12}>
                <Row>
                  <Col className="mt-3" md={9}>
                    <CapturedvsReplenished months={months} capture={capture} replenished={replenished} />
                  </Col>
                  <Col md={3} className="mt-3">
                    <Card
                      className="h-100 border-1"
                      style={{ borderRadius: "4px" }}
                    >
                      <CardHeader
                        className="border-0 bg-white"
                        style={{ borderRadius: "4px" }}
                      >
                        <Row className="align-items-center">
                          <Col className="d-flex justify-content-between">
                            <CardTitle
                              className="f-20 font-weight-600 mb-0 scroll"
                              style={{ color: "#212121" }}
                            >
                              Financial
                              <span className="d-block">Summary</span>
                            </CardTitle>
                            <img src={FinacialIcon} />
                          </Col>
                        </Row>
                        <div className="mt-3">
                          {counterData?.map((item, index) => {
                            return (
                              <div
                                key={index}
                                className="mt-3 border-btm-line"
                              >
                                <div className="finacial-heading">
                                  <CTooltip
                                    content={
                                      <div className="tip-list-info">
                                        <p>{item.tooltip}</p>
                                      </div>
                                    }
                                  >
                                    <span className="finacial-heading">
                                      {item.iconName}
                                    </span>
                                  </CTooltip>
                                </div>
                                <div className="finacial-value mt-2">
                                  {item?.value ? item.value : " -"}
                                </div>
                                <div className="border" style={{ marginBottom: '25px', marginTop: '10px' }}></div>
                              </div>
                            );
                          })}
                        </div>
                      </CardHeader>

                    </Card>
                  </Col>
                </Row>

              </Col>

              <Col className='mt-3' md={6}>
                <ProgramRevenue months={months} dispFee={dispFee} />
              </Col>
              <Col className='mt-3' md={6}>
                <ContractsAndCEs months={months} ces={ces} contracts={contracts} />
              </Col>
            </Row>


            <Row sm={2} xs={1}>
              <Col className='mt-3'>
                <TopNDCs data={top10ndcs} />
                {/* <BarWidget name='Top Performing Pharmacies' color="primary" data={performingData} /> */}
              </Col>
              <Col className='mt-3'>
                <TopCoveredEntities data={top10ces} />
              </Col>
              <Col className='mt-3'>
                <TopPharmacy data={top10phs} />
                {/* <BarWidget name='Top 10 Prescribers' color="blue" data={prescriberData} /> */}
              </Col>
              <Col className='mt-3'>
                <BottomPharmacy data={bottom10phs} />
                {/* <BarWidget name='Top 10 Prescribers' color="blue" data={prescriberData} /> */}
              </Col>
            </Row>
          </CardBody>
        </Card>

      </Container>
    </div >
    </div>
  );
};

export default Dashboard;

